import Vue from 'vue'
import Router from 'vue-router'
import Payments from '@/components/Payments/Payments.vue'
import Checkout from '@/components/Checkout/Checkout.vue'
import Login from '@/components/Login/Login.vue'
import Signup from '@/components/Signup/Signup.vue'
import PageNotFound from '@/components/PageNotFound/PageNotFound.vue'
import Account from '@/components/Account/Account.vue'
import EditProfile from '@/components/Account/EditProfile.vue'
import LinkAccount from '@/components/Account/LinkAccount'
import Transactions from '@/components/Account/Transactions'
import Verification from '@/components/Account/Verification'
import Wallets from '@/components/Wallets/Wallets'
import Cards from '@/components/Cards/Cards'
import ResetPassword from '@/components/ResetPassword/ResetPassword'
import CoockiesPolicy from '@/components/CoockiesPolicy'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import TermsAndConditions from '@/components/TermsAndConditions'
import ContactUs from '@/components/ContactUs'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Payments',
    component: Payments,
    meta: {
      title: 'Payments'
    }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: {
      title: 'Checkout'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      title: 'Signup'
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      title: 'Account'
    }
  },
  {
    path: '/account/link',
    name: 'LinkAccount',
    component: LinkAccount,
    meta: {
      title: 'Link Wallet'
    }
  },
  {
    path: '/account/link/wallets',
    name: 'Wallets',
    component: Wallets,
    meta: {
      title: 'Wallets'
    }
  },
  {
    path: '/account/verification',
    name: 'Verification',
    component: Verification,
    meta: {
      title: 'Account Verification'
    }
  },
  {
    path: '/account/link/cards',
    name: 'Cards',
    component: Cards,
    meta: {
      title: 'Credit Cards'
    }
  },
  {
    path: '/account/edit',
    name: 'EditProfile',
    component: EditProfile,
    meta: {
      title: 'Edit Profile'
    }
  },
  {
    path: '/account/transactions',
    name: 'Transactions',
    component: Transactions,
    meta: {
      title: 'Transaction History'
    }
  },
  {
    path: '/account/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: 'Reset Password'
    }
  },
  {
    path: '/coockies-policy',
    name: 'CoockiesPolicy',
    component: CoockiesPolicy,
    meta: {
      title: 'Coockies Policy'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy'
    }
  },
  {
    path: '/tos',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      title: 'Terms Of Service'
    }
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      title: 'HaitiPay - Contact Us'
    }
  },
  {
    path: '*',
    name: 'Not Found',
    component: PageNotFound,
    meta: {
      title: 'Page Not Found'
    }
  }
]

const options = {
  mode: 'history',
  routes
}

const router = new Router(options)

router.beforeEach((to, from, next) => {
  let pageTitle = to.meta.title
  if (to.query.b) pageTitle += ` - ${to.query.b}`
  document.title = pageTitle
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js